import Toaster from "src/Toaster/Toaster";

type OnlyGetChangedFieldsProps = {
	handleFun: (value: Record<string, any>) => void;
	dirtyFields: Record<string, any>;
	formValue: Record<string, any>;
	additionalFields?: Record<string, any>; // Optional additional fields
};

const onlyGetChangedFields = ({
	handleFun,
	dirtyFields,
	formValue,
	additionalFields = {},
}: OnlyGetChangedFieldsProps): Record<string, any> | void => {
	const Toast = Toaster();
	const updatedFields: Record<string, any> = {};

	// Process dirty fields
	for (const key in dirtyFields) {
		if (dirtyFields[key]) {
			updatedFields[key] = formValue[key];
		}
	}

	// Include additional fields if changes are detected
	if (Object?.keys(updatedFields)?.length > 0) {
		const result = { ...updatedFields, ...additionalFields };
		handleFun(result);
		return result; // Return the updated fields
	} else {
		Toast.fire({
			icon: "error",
			title: "Change Field First",
		});
	}

	return updatedFields || {};
};

export default onlyGetChangedFields;
